/**
 * Cookie Consent Banner
 * GDPR-compliant bottom banner shown on first visit
 * Stores consent in localStorage, shows only once per device
 */

import { useState, useEffect } from 'react';
import { Link } from 'react-router';

const CONSENT_KEY = 'cookieConsent';

export function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if consent was already given
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      // Small delay to avoid flash on initial load
      const timer = setTimeout(() => setIsVisible(true), 500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'true');
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 bg-bg-surface border-t border-border shadow-lg"
      role="dialog"
      aria-labelledby="cookie-consent-title"
      aria-describedby="cookie-consent-description"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          {/* Message */}
          <div className="flex-1">
            <p id="cookie-consent-description" className="text-sm text-text-secondary">
              Folosim <strong className="text-text-primary">cookie-uri esențiale</strong> pentru
              funcționarea site-ului (autentificare, securitate). Nu folosim cookie-uri de
              <Link
                to="/cookie-uri"
                className="text-accent hover:text-accent-hover underline"
              >
                Află mai multe
              </Link>
            </p>
          </div>

          {/* Accept button */}
          <button
            onClick={handleAccept}
            className="flex-shrink-0 px-6 py-2 bg-accent hover:bg-accent-hover text-bg-base font-medium rounded-lg transition-colors text-sm"
          >
            Am înțeles
          </button>
        </div>
      </div>
    </div>
  );
}
